// extracted by mini-css-extract-plugin
export var active = "_gn-7";
export var blink = "_gn-8";
export var dropDownSelector = "_gn-4";
export var dropDownWrapper = "_gn-3";
export var fakeCursor = "_gn-6";
export var fontSizeButton = "_gn-9";
export var formQuillEditor = "_gn-0";
export var pressed = "_gn-a";
export var qlBlank = "_gn-1";
export var textFormattingToolbar = "_gn-2";
export var textToolbarOption = "_gn-5";